(function() {
  'use strict';
  
  angular
    .module('app.auth', []);
  
})();